import React from "react"
import { Field, ErrorMessage } from "formik"

const FormikTextarea = ({
  label,
  name,
  placeholder = "",
  rows = 3,
  disabled = false,
  required = false,
  helpText = "",
  maxLength,
  containerClassName = "mb-3",
  labelClassName = "form-label",
  textareaClassName = "",
  showCharacterCount = false,
  // Allow passing custom props to both container and textarea
  ...props
}) => {
  return (
    <div className={containerClassName}>
      {label && (
        <label htmlFor={name} className={labelClassName}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}

      <Field name={name}>
        {({ field, form: { touched, errors, values } }) => {
          const isInvalid = touched[name] && errors[name]
          const isValid = touched[name] && !errors[name]
          const currentLength = values[name]?.length || 0

          return (
            <>
              <textarea
                {...field}
                {...props}
                id={name}
                rows={rows}
                maxLength={maxLength}
                placeholder={placeholder}
                disabled={disabled}
                className={`
                  form-control
                  ${isInvalid ? "is-invalid" : ""}
                  ${isValid ? "is-valid" : ""}
                  ${textareaClassName}
                `.trim()}
                aria-describedby={`${name}-feedback ${name}-help ${name}-count`}
              />

              {/* Character Count */}
              {(showCharacterCount || maxLength) && (
                <div
                  id={`${name}-count`}
                  className={`form-text text-end ${
                    maxLength && currentLength >= maxLength * 0.9 ? "text-danger" : "text-muted"
                  }`}
                >
                  {currentLength}
                  {maxLength && ` / ${maxLength}`} characters
                </div>
              )}

              {/* Error Message */}
              <ErrorMessage name={name}>
                {(msg) => (
                  <div id={`${name}-feedback`} className="invalid-feedback">
                    {msg}
                  </div>
                )}
              </ErrorMessage>

              {/* Help Text */}
              {helpText && (
                <div id={`${name}-help`} className="form-text text-muted">
                  {helpText}
                </div>
              )}
            </>
          )
        }}
      </Field>
    </div>
  )
}

export default FormikTextarea
